module.exports = __webpack_public_path__ + "static/media/IMG_5285.75c2fbc3.JPG";